import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material/styles';

const theme = createTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ['Open Sans'].join(','),
    },

    breakpoints: {
      values: {
        sm: 600, // Small screen / phone
        md: 920, // Medium screen / tablet
        lg: 1200, // Large screen / desktop
        xl: 1500,
        xs: 0,
        // xxl: 1800,
      },
    },

    palette: {
      contrastThreshold: 3,
      primary: {
        main: '#006997',
        contrastText: '#fff',
      },
      secondary: {
        main: '#D9E9F0',
        contrastText: '#ffffff',
      },
      error: {
        main: '#bf1f2c',
      },
      success: {
        main: '#0abb87',
      },
    },
  }
);

export default function ThemeProvider(props: { children: React.ReactNode }) {
  const { children } = props;

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
